// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"recalculate-metrics__wrapper--15QLe","module_wrapper":"recalculate-metrics__module_wrapper--2acP_","moduleWrapper":"recalculate-metrics__module_wrapper--2acP_"};